import * as Yup from 'yup';
import { Portal } from '../../../api/organization/onboardingTypes';

const validationSchema = Yup.object({
  login: Yup.string().required('Login is required'),
  password: Yup.string().required('Password is required'),
});

const riayatiValidationSchema = Yup.object({
  login: Yup.string()
    .min(5, 'License must be at least 5 characters')
    .required('License is required'),
  password: Yup.string()
    .matches(
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
      'API Key must be a valid UUID format'
    )
    .required('API Key is required'),
});

const shafafiyaValidationSchema = Yup.object({
  login: Yup.string()
    .min(1, 'Username must be at least 1 character')
    .required('Username is required'),
  password: Yup.string()
    .matches(
      /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).+$/,
      'Password must contain at least one uppercase letter and one special character'
    )
    .required('Password is required'),
});

const eClaimLinkValidationSchema = Yup.object({
  login: Yup.string()
    .min(1, 'Username must be at least 1 character')
    .required('Username is required'),
  password: Yup.string()
    .matches(
      /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).+$/,
      'Password must contain at least one uppercase letter and one special character'
    )
    .required('Password is required'),
});

export const getValidationSchema = (portal: Portal) => {
  switch (portal) {
    case Portal.Riayati:
      return riayatiValidationSchema;
    case Portal.Shafafiya:
      return shafafiyaValidationSchema;
    case Portal.eClaimLink:
      return eClaimLinkValidationSchema;
    default:
      return validationSchema;
  }
};
